import React from "react";
import { useField } from "formik";
import { FormControlLabel } from "@mui/material";
import ChipInput from "@jansedlon/material-ui-chip-input";
import { ErrorMessage, FormikProps, FormikValues, getIn, useFormikContext } from "formik";

const ChipInputField = (props: any) => {
  const formik: FormikProps<FormikValues> = useFormikContext();

  const { name, label, rows, multiline, variant, disabled,...rest } = props;
  const [field] = useField(props);
  const { setFieldValue } = useFormikContext();

  const handleChange = (e: any) => {
    setFieldValue(field.name, e);
  };

  return (
    <FormControlLabel
      control={
        <ChipInput
          label={label}
          variant={variant ? variant : "outlined"}
          fullWidth
          disabled={disabled}
          aria-multiline={multiline}
          aria-rowspan={rows}
          onChange={(e) => handleChange(e)}
          defaultValue={field.value}
          helperText={<ErrorMessage name={name} />}
          error={getIn(formik.touched, name) && getIn(formik.errors, name)}
        />
      }
      sx={{ width: "100%", ml: 0 }}
      {...rest}
    />
  );
};

export default ChipInputField;
